import { CountryBudgetDecision } from 'nomst/Stores/Decision/countryBudgetDecision';
import { AmountCode } from 'typings/enums';
import { ICountryDecisionDispatcher } from 'typings/countryDecision.dispatcher';

export class CountryBudgetDecisionDispatcher implements ICountryDecisionDispatcher {
    private readonly _countryBudgetDecision: Nullable<CountryBudgetDecision>;

    constructor(countryBudgetDecision: Nullable<CountryBudgetDecision>) {
        this._countryBudgetDecision = countryBudgetDecision;
    }

    dispatchEmployeeSelection(employeeSourceId: string): Promise<void> {
        if (!this._countryBudgetDecision) {
            return Promise.resolve();
        }
        return this._countryBudgetDecision?.handleEmployeeSelection(employeeSourceId);
    }

    dispatchDeselectEmployee(): void {
        this._countryBudgetDecision?.deselectEmployee();
    }

    dispatchSelectConversation(entityId: string): void {
        this._countryBudgetDecision?.selectConversation(entityId);
    }

    dispatchDeselectConversation(): void {
        this._countryBudgetDecision?.deselectConversation();
    }

    // tslint:disable:parameters-max-number
    dispatchAmountChanged(
        amountCode: AmountCode,
        amountIsoCurrencyCode: string,
        previousAmountValue: number,
        currentAmountValue: number,
        updateNewPay: boolean,
        isHourly: boolean,
        annualStandardWorkHours: number,
        fullTimeEquivalent: number): void {
        this._countryBudgetDecision?.handleAmountChanged(
            amountCode,
            amountIsoCurrencyCode,
            previousAmountValue,
            currentAmountValue,
            updateNewPay,
            isHourly,
            annualStandardWorkHours,
            fullTimeEquivalent);
    }

    dispatchAmountUpdated(
        employeeSourceId: string,
        amountCode: AmountCode): void {
        this._countryBudgetDecision?.handleAmountUpdated(employeeSourceId, amountCode);
    }
}